import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { customInMemoryCache } from "./cache";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { store } from "../store/store";
import { logoutUser } from "../store/userSlice";
import { dispatchSessionExpired } from "../Components/Common/SessionExpiredModal";

const configuredGraphqlUrl = (process.env.REACT_APP_GRAPHQL_URL || "").trim();

const URL = process.env.REACT_APP_GRAPHQL_URL 

if (process.env.NODE_ENV !== "production") {
  console.info("[Apollo] GraphQL URL:", URL);
}


const httpLink = createUploadLink({
  uri: URL,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("mamaketUserToken") ;


  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
         "content-type": "application/json",
        'apollo-require-preflight': true,
    },
  };
});

const handleSessionExpired = () => {
  localStorage.removeItem("mamaketUserToken");
  localStorage.removeItem("tokenExpiresIn");
  store.dispatch(logoutUser());
  dispatchSessionExpired();
};

const isSessionExpiredError = (message) => {
  return message && String(message).toLowerCase().includes("login session expired");
};

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
    for (const { message, locations, path, extensions } of graphQLErrors) {
      console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);

      if (
        extensions?.code === "UNAUTHENTICATED" ||
        message?.includes("Not authorized") ||
        isSessionExpiredError(message)
      ) {
        handleSessionExpired();
        return;
      }
    }
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);

    if (networkError.statusCode === 401) {
      handleSessionExpired();
      return;
    }

    // Handle 400 with "Login session expired" (may appear in result.errors)
    if (networkError.statusCode === 400 && networkError.result) {
      const errors = networkError.result?.errors;
      if (Array.isArray(errors)) {
        const hasSessionExpired = errors.some((err) =>
          isSessionExpiredError(err?.message)
        );
        if (hasSessionExpired) {
          handleSessionExpired();
          return;
        }
      }
    }
  }

  return forward(operation);
});

const client = new ApolloClient({
  link: errorLink.concat(authLink).concat(httpLink),
  cache: customInMemoryCache,
});

export default client;
